function Header() {
  return (
    <div className="w-full flex flex-col items-center relative text-custom_black py-14">
      <h1>خدمات</h1>
      <p className="font-thin text-custom_pink">
        خدماتی که من میتوانم به شما ارائه دهم.
      </p>
    </div>
  );
}

export default Header;